module.exports = "<div class=page-content> <div class=row> <div ng-include=\"'views/sidebar.html'\"></div> <div class=col-md-10> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/views/config.html
// module id = 1358
// module chunks = 0